'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.provider('localStorage', function () {

    var _this = this;

    // 当前项目标识 用于存储
    _this.appIdentification = '';

    _this.$get = function () {

      var _this = this;

      var _res = {
        appIdentification: _this.appIdentification
      };

      _res.set = function (key, data) {
        return window.localStorage.setItem(_this.appIdentification + key, window.JSON.stringify(data));
      };
      _res.get = function (key) {
        return window.JSON.parse(window.localStorage.getItem(_this.appIdentification + key));
      };
      _res.remove = function (key) {
        return window.localStorage.removeItem(_this.appIdentification + key);
      };

      return _res;
    };

    return _this;
  });
  return app;
};

require('angular');

/**
 * html5 本地存储
 */

;


//////////////////
// WEBPACK FOOTER
// ./src/lib/angular1.x-common/services/localStorage.js
// module id = 151
// module chunks = 0